module.exports = __webpack_public_path__ + "static/SouthernCross_MemberCard-de15a69bef5111e339b868c3bd7bee3c.jpg";